import type { CSSProperties } from "react";
import styles from "./BriefingIntro.module.css";
import type { StageIntroVariantProps } from "./types";

/** Pattern B: an editorial mission briefing with a numbered list. */
export default function BriefingIntro({ stageLabel, conditions }: StageIntroVariantProps) {
  return (
    <section className={styles.sheet}>
      <header className={styles.header}>
        <span>MISSION BRIEFING</span>
        <span>{stageLabel}</span>
      </header>
      <ol className={styles.list}>
        {conditions.map((condition, index) => (
          <li key={condition.id} style={{ "--power": condition.color, "--i": index } as CSSProperties}>
            <span className={styles.number}>{index + 1}</span>
            <span className={styles.force}><b>{condition.label}</b>{condition.name}</span>
            <strong className={styles.word} lang="en">{condition.text}</strong>
            <span className={styles.gloss}>{condition.gloss}</span>
          </li>
        ))}
      </ol>
      <p className={styles.note}>3つすべてに近い意味の英単語ほど、強い弾になる。</p>
    </section>
  );
}
